import { ExistingUserWelcomeToProactiveModal } from "@/components/onboarding/components/welcome-wizard/steps/mem-agent/existing-user-onboarding-pages";
import { WelcomeToProactiveModal } from "@/components/modal/welcome-to-proactive/welcome-to-proactive";
import { useAppStore } from "@/store";
import { observer } from "mobx-react-lite";

/** Owns the handoff from confirmed Proactive access into user-directed Agent setup. */
export const ProactiveCheckoutCompletionModal = observer(() => {
  const { store } = useAppStore();

  const handleContinue = () => {
    if (store.onboarding.existingUserProactiveTrialWelcomeIsPending) {
      store.platformInfo.perDeviceOnboardingInfo.completeOrSkipProactiveTrialOnboarding();
      store.onboarding.finishExistingUserProactiveTrialWelcome();
      store.platformInfo.closeWelcomeToProactiveModal();
      return;
    }

    store.platformInfo.closeWelcomeToProactiveModal();
    store.floatingAgent.requestOpenPanel();
  };

  if (store.onboarding.existingUserProactiveTrialWelcomeIsPending) {
    return (
      <ExistingUserWelcomeToProactiveModal
        isOpen={store.platformInfo.welcomeToProactiveModalIsOpen}
        onContinue={handleContinue}
      />
    );
  }

  return (
    <WelcomeToProactiveModal
      isOpen={store.platformInfo.welcomeToProactiveModalIsOpen}
      onClose={handleContinue}
    />
  );
});
